import log from 'salvo-lite/log'
import getNodeDimensions from 'get-node-dimensions'

class SlidingMenu {
    constructor (theme, elem) {
        this._elem = elem
        this._slidingArea = elem.querySelector('[data-moving-container]')
        this._navItems = elem.querySelectorAll('[data-nav-item]')
        this._width = getNodeDimensions(this._elem).width
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)

        for (let navItem of this._navItems) {
            let navLinks = navItem.querySelectorAll('[data-level]')

            for (let link of navLinks) {
                let linkLevel = parseInt(link.dataset.level)
                let menuArea = link.dataset.menuArea
                link.addEventListener('click', (e) => {
                    e.preventDefault()
                    if (menuArea) {
                        this.showMenu(linkLevel, menuArea)
                    }
                    this.goToLevel(linkLevel)
                })
            }
        }

        this.setWidths()

        log.debug(this.constructor.name, 'Initialized', this)
    }

    setWidths () {
        this._slidingArea.style.minWidth = `${this._width * 3}px`
        for (let navItem of this._navItems) {
            navItem.style.width = `${this._width}px`
        }
    }

    showMenu (level, menuHandle) {
        let toHide = this._elem.querySelectorAll(`[data-nav-item='${level}'] > nav`)
        let toShow = this._elem.querySelector(`[data-nav-item='${level}'] [data-menu-area='${menuHandle}']`)
        for (let navItem of toHide) {
            navItem.classList.add('hide')
        }
        toShow.classList.remove('hide')
    }

    goToLevel (level) {
        for (let navItem of this._navItems) {
            navItem.classList.remove('shown')
        }

        if (this._navItems[level - 1]) {
            this._navItems[level - 1].classList.add('shown')
        }

        this._elem.scrollTo(0, 0)

        let transform = `translateX(-${(level - 1) * this._width}px)`
        this._slidingArea.style.webkitTransform = transform
        this._slidingArea.style.MozTransform = transform
        this._slidingArea.style.msTransform = transform
        this._slidingArea.style.OTransform = transform
        this._slidingArea.style.transform = transform
    }
}

export default SlidingMenu



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SlidingMenu.js